import Icon, { HistoryOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Drawer, Flex, Grid } from 'antd';
import { LinkButton } from './components/button/link-button';
import { SidebarVKSButton } from './components/button/vks';
import { Last10Applications } from './components/list/applications';
import './index.css';
import { IconAsistaText } from '../icon/asista-logo/text';
import { IconAsistaLogo } from '../icon/asista-logo/logo';
import { IconSidebarButton } from '../icon/sidebar-button';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import styles from './index.module.css';
import { useState } from 'react';
import { Translate } from '../../../Components/UI/Translate/Translate';

export const SidebarMenu = (props) => {

    const screens = Grid.useBreakpoint();

    const dispatch = useDispatch();

    const onCreateNewTask = () => dispatch(push(`/application/${props.id}/newticket`));

    return (
        screens.md ?
            <WebSidebarMenu
                {...props}
                onCreateNewTask={onCreateNewTask}
            />
            :
            <MobileSidebarMenu
                {...props}
                onCreateNewTask={onCreateNewTask}
            />
    )
}

export const WebSidebarMenu = (props) => {

    const dispatch = useDispatch();

    const className = [
        'sidebar-menu-container',
        props.open ? 'sidebar-menu-container-open' : ''
    ].filter(Boolean).join(' ');

    const clientName = useSelector(state => state.applications.clientName)

    const navigateToPrelogin = () => {
        dispatch(push(`/prelogin/${props.id}`));
    }


    return (
        <Flex className={className} vertical>
            <Flex align='start' style={{
                marginBottom: props.open ? 0 : 36, transition: 'all 0.3s ease-in-out',
                padding: 16
            }}>
                <Flex align='end' onClick={navigateToPrelogin} className='sidebar-menu-logo' justify='center' style={{ marginLeft: 4 }}>
                    <IconAsistaLogo />
                    <IconAsistaText style={{
                        maxWidth: props.open ? 145 : 0,
                        opacity: props.open ? 1 : 0,
                        marginLeft: props.open ? 8 : 0,
                        transition: 'all 0.3s ease-in-out'
                    }} />
                </Flex>
                <Button
                    type="text"
                    size='large'
                    onClick={props.onToggle}
                    icon={
                        <Flex align='center' justify='center' style={{ width: 24, height: 24 }}>
                            <IconSidebarButton open={props.open} />
                        </Flex>
                    }
                    className={props.open ? 'sidebar-menu-toggle-btn sidebar-menu-toggle-btn-open' : 'sidebar-menu-toggle-btn'}
                    style={{
                        position: 'absolute',
                        left: 0,
                        zIndex: 1,
                        willChange: 'transform',
                    }}
                />
            </Flex>
            <Flex vertical style={{
                padding: 8
            }}>
                <LinkButton
                    icon={<PlusOutlined />}
                    children={'Создать заявку'}
                    open={props.open}
                    onClick={props.onCreateNewTask}
                />
                {
                    clientName.cua_access_management && (
                        <LinkButton
                            icon={
                                <Icon
                                    component={() => (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 12 12" fill="none">
                                            <g clip-path="url(#clip0_679_3633)">
                                                <path d="M2.0692 9.3167C3.23013 8.6605 4.57135 8.28599 6.00004 8.28599C7.42872 8.28599 8.76994 8.6605 9.93087 9.3167M7.71432 4.85742C7.71432 5.8042 6.94681 6.57171 6.00004 6.57171C5.05326 6.57171 4.28575 5.8042 4.28575 4.85742C4.28575 3.91065 5.05326 3.14314 6.00004 3.14314C6.94681 3.14314 7.71432 3.91065 7.71432 4.85742ZM11.1429 6.00028C11.1429 8.8406 8.84036 11.1431 6.00004 11.1431C3.15971 11.1431 0.857178 8.8406 0.857178 6.00028C0.857178 3.15996 3.15971 0.857422 6.00004 0.857422C8.84036 0.857422 11.1429 3.15996 11.1429 6.00028Z" stroke="currentColor" stroke-width="0.914286" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_679_3633">
                                                    <rect width="12" height="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    )}
                                />
                            }
                            onClick={() => props.openHR()}
                            children={'Приём/увольнение'}
                            open={props.open}
                        />
                    )
                }
                <SidebarVKSButton id={props.id} open={props.open} />
            </Flex>
            <Last10Applications id={props.id} open={props.open} />
            {/* <Flex justify='center' className={styles.lang}>
                <Translate hideLabel={!props.open} hideFlags={props.open} />
            </Flex> */}
        </Flex>
    )
}

export const MobileSidebarMenu = (props) => {

    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <Flex className={styles.container} justify='center'>
            <Flex gap={15}>
                <Button
                    type='text'
                    size='large'
                    style={{ padding: 8 }}
                    icon={
                        <PlusOutlined
                            onClick={props.onCreateNewTask}
                            style={{ fontSize: 30, color: 'rgba(0, 0, 0, 0.76)' }}
                        />
                    }
                >
                </Button>
                <Button
                    type='text'
                    size='large'
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    style={{ padding: 8, fontSize: 30, color: 'rgba(0, 0, 0, 0.76)' }}
                    icon={
                        <HistoryOutlined />
                    }
                />
                {/* <div className={styles.lang_mobile}>
                    <Translate hideLabel/>
                </div> */}
                <Drawer
                    open={drawerOpen}
                    title="История заявок"
                    placement="left"
                    onClose={() => setDrawerOpen(false)}
                    size='default'
                >
                    <Last10Applications
                        open
                        hideTitle
                        id={props.id}
                        onOpenHistoryApp={() => setDrawerOpen(false)}
                    />
                </Drawer>
            </Flex>
        </Flex>
    )
}